import {Component, OnInit} from '@angular/core';
import {HeaderComponent} from './shared/header/header.component';
import {RouterOutlet} from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { LoggedUser } from './auth/interfaces/logged-user';
import { AuthService } from './auth/services/auth.service';

@Component({
  selector: 'app-root',
  imports: [
    HeaderComponent,
    RouterOutlet
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{
  title = 'friends-payment-fe';
  loggedUser: LoggedUser | null = null;

  constructor(private readonly authService: AuthService) {
  }

  decodeToken() {
    this.authService.getTokenNoAsync().then(token => {
      this.loggedUser = jwtDecode(token);
      this.authService.setLoggedUserOnLocalStorage(token);
    });
  }

  ngOnInit(): void {
    this.decodeToken();
  }
}
